// AtplMedPanel.js — ATPL & MED MODÜLÜ (5 Eyl 2026)
//
// 🔑 Serkan: *"Bu gereklilikleri yeni bir modüle koyacağız — 'ATPL and MED',
//    FTL modülün altına yeni modül. Burada tanımlı pilotların tek tek
//    verilerini gireceğiz."* · *"ATPL ve MED modülde girdileri yapacağız, aynı
//    veriler başka bir modülde de takip edilebilir olabilir, hepsi Supa'da tek
//    kaynaktan çeker."* · *"Mantık aynı: veri tek yerde, her şeyi besler."*
//
// 🔴 NEDEN GEREKLİ — ölçüldü (5 Eyl 2026): DOĞUM TARİHİ `pilot_trainings`
//    SATIRININ İÇİNDE duruyordu. Bir kişinin doğum tarihi, bir eğitim kaydına
//    gömülüydü. Sonucu: FCL.065 (60/65 yaş) hiç uygulanamıyor, MED.A.045'in
//    "40/60 yaş → 6 ay" hesabı o satır girilmeden çalışmıyor, aynı kişinin iki
//    kaydında farklı doğum tarihi olabiliyordu.
//
// BU MODÜL GİRİŞ NOKTASIDIR, TEK OKUYUCU DEĞİL: tekrarlayan kontroller
// (OPC/LPC/LC/CRM/DG/EMERG/SEC) `pilot_trainings`te kalır ve oradaki 60/30/15
// motoru çalışmaya devam eder — ikinci bir tarih takibi kurmak İlke 3'ü
// çiğnerdi. Buradaki OLGULAR o modüle ve atama kapısına beslenir.
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { supabase } from '../supabaseClient';
import InfoDot from './InfoDot';
import Katlanir from './Katlanir';
import { dugmeStili, zAlan } from './tasarim';
// 🔑 Serkan (6 Eyl 2026): *"Oraya tıklayınca ülkeler ve kodları çıksın hücrede,
//    aynı simülatör görevinde yaptığımız gibi — elle yazmayalım."*
//    Liste YENİDEN YAZILMAZ: `tzCatalog` zaten 247 ülkeyi ISO koduyla taşıyor
//    ve LocationPicker de onu kullanıyor (İlke 3).
import { TZ_ULKELER } from '../data/tzCatalog';
import { fclBloklari, fclKunyesi, fclSirketKurallari, fclGeceTanimi,
         fclOlculebilirlik } from './FTLRuleCatalog';
import { fclMetni } from '../data/fclArticles';
// 🔑 EŞİKLER TEK YERDE (5 Eyl 2026, Serkan onayı). Yeni bir uyarı motoru
//    YAZILMADI: TRAINING'in 60/30/15'i çağrılır. İki kopya olsaydı yarın biri
//    60'ı 45 yapar, öbürü olduğu yerde kalırdı (İlke 3).
import { trainingStatus, STATE_COLOR, todayLocal } from './TrainingRules';
// 🔑 Muayene son tarihi TEK YERDE hesaplanır — form, tablo ve zil aynı
//    fonksiyonu çağırır (İlke 3).
import { medBitisi } from './LicenceAlerts';
// 🔑 ŞİRKETİN yerel günü (21 Eyl 2026, Serkan: *"ana üs yereli"*).
import { useSirketDilimi, dilimUyarisi } from './sirketDilimi';   // uyarı metni tek kaynak (14 Eki 2026: okunamadı ≠ yok)
import HarfliGiris from './HarfliGiris';
import { bildirimleriTazele } from './bildirimOlayi';
// 🔑 Kod tablosu SAF VERİ modülünde (`data/medLimitations.js`) — motor da
//    aynı yerden okur ve o motor Edge Function'dan Deno altında çalışıyor,
//    bu yüzden tablo bir React dosyasında duramaz (İlke 3).
import { MED_KISITLAMALARI, AMC_KUNYE, kisitlama, kisitlamaSecenekleri }
  from '../data/medLimitations';
import { ucusEkibindenMi } from '../roller';
import { vw } from '../yaziBoyutu';
import { usePencereKapat, KapatX } from './pencereKapat';   // pencere kapatma tek tip — ESC + ✕ (12 Eki 2026)
import IsaretKutusu from './IsaretKutusu';
import { GerekceIpucu, gerekceTamam, gerekceIpucuMetni } from './gerekce';   // ortak gerekçe kuralı + satırı (21 Eki 2026, K7)

// Zorunlu alan rengi (iPad kuralı, 5 Eki 2026) + SAVE'e basıldıktan sonra eksikse KIRMIZI vurgu (6 Eyl 2026'dan beri) — kırmızı
// amberin üstüne yazılır. Alanlar yalnız ilgili kod seçiliyken çizilir: görünüyorsa zorunludur (kapı `eksikVeriler`).
const zKayit = (taban, dolu, kirmizi) => {
  const z = zAlan(taban, true, dolu);
  return kirmizi ? { ...z, style: { ...z.style, borderColor: 'var(--red)' } } : z;
};

const C = {
  bg2:'var(--bg2)', bg3:'var(--bg3)', border:'var(--border)', border2:'var(--border2)',
  accent:'var(--accent)', green:'var(--green)', red:'var(--red)', amber:'var(--amber)',
  t1:'var(--t1)', t2:'var(--t2)', t3:'var(--t3)',
};
const S = {
  wrap:{ padding:20 },
  panel:{ background:C.bg2, border:`1px solid ${C.border}`, borderRadius:8, marginBottom:16 },
  panelH:{ padding:'10px 16px', borderBottom:`1px solid ${C.border}`, background:C.bg3,
           display:'flex', alignItems:'center', gap:10 },
  panelT:{ fontSize:11, fontWeight:700, letterSpacing:1.5, color:C.accent,
           fontFamily:'var(--mono)', textTransform:'uppercase' },
  table:{ width:'100%', borderCollapse:'collapse' },
  th:{ padding:'8px 12px', fontSize:9.5, fontWeight:700, letterSpacing:1.2, color:C.t3,
       fontFamily:'var(--mono)', textAlign:'left', borderBottom:`1px solid ${C.border}`,
       whiteSpace:'nowrap' },
  td:{ padding:'8px 12px', fontSize:12, color:C.t1, borderBottom:`1px solid ${C.border}`,
       fontFamily:'var(--mono)', whiteSpace:'nowrap' },
  label:{ fontSize:10, color:C.t3, fontFamily:'var(--mono)', letterSpacing:1,
          textTransform:'uppercase', display:'block', marginBottom:5 },
  input:{ width:'100%', background:C.bg3, border:`1px solid ${C.border2}`, color:C.t1,
          padding:'7px 9px', fontSize:12, fontFamily:'var(--mono)', borderRadius:4 },
  // 1 Eki 2026 — düğmeler ORTAK tasarımdan (tasarim.js, Serkan: "her modülün içinde butonlarda border, aynı tasarım"); eskiden bu dosyada ayrı tanımlıydı.
  btnP:dugmeStili('birincil'),
  btnS:dugmeStili('notr', { kucuk: true }),
  note:{ padding:'9px 12px', background:C.bg3, borderLeft:`2px solid ${C.border2}`,
         fontSize:11, color:C.t2, lineHeight:1.7, margin:'12px 0' },
};
const badge = (renk) => ({ display:'inline-block', padding:'1px 7px', borderRadius:3, fontSize:9,
  fontWeight:700, letterSpacing:1, fontFamily:'var(--mono)',
  color: renk === 'red' ? C.red : renk === 'amber' ? C.amber : renk === 'green' ? C.green : C.t3,
  border:`1px solid ${renk === 'red' ? C.red : renk === 'amber' ? C.amber : renk === 'green' ? C.green : C.border2}`,
  background:'transparent' });

const LISANS = ['ATPL', 'CPL', 'MPL', 'PPL'];

/** Doğum tarihinden bugünkü tam yaş — FCL.065 ve MED.A.045 bundan beslenir. */
export function yas(dob, bugun = null) {
  if (!dob) return null;
  const d = new Date(dob), b = bugun ? new Date(bugun) : new Date();
  if (isNaN(d) || isNaN(b)) return null;
  let y = b.getUTCFullYear() - d.getUTCFullYear();
  const ay = b.getUTCMonth() - d.getUTCMonth();
  if (ay < 0 || (ay === 0 && b.getUTCDate() < d.getUTCDate())) y--;
  return y;
}

/**
 * FCL.065 — ticari hava taşımacılığında yaş kısıtı.
 * *"(a) 60-64 yaş: … ÇOK PİLOTLU EKİBİN BİR ÜYESİ OLMADIĞI SÜRECE … uçamaz.
 *   (b) 65 yaş: … uçamaz."*
 * @returns {null|{state,text}} null = kısıt yok
 */
export function fcl065(dob, bugun = null) {
  const y = yas(dob, bugun);
  if (y == null) return null;
  if (y >= 65) return { state:'red', age:y,
    text:'65 yaşını doldurmuş pilot lisansı sahipleri, ticari hava taşımacılığı yapan bir hava '
       + 'aracının pilotu olarak uçamaz (FCL.065(b)).' };
  if (y >= 60) return { state:'amber', age:y,
    text:'60 yaşını doldurmuş pilot, ÇOK PİLOTLU ekibin bir üyesi olmadığı sürece ticari hava '
       + 'taşımacılığında pilot olarak uçamaz (FCL.065(a)).' };
  return null;
}

export default function AtplMedPanel({ toast, myProfile, pilots, readOnly = false }) {
  const [kayitlar, setKayitlar] = useState({});     // pilot_id → en yeni satır
  const [yukleniyor, setYukleniyor] = useState(true);
  const [duzenlenen, setDuzenlenen] = useState(null);
  const [form, setForm] = useState({});
  const [kaydediliyor, setKaydediliyor] = useState(false);
  usePencereKapat(kaydediliyor ? null : () => setDuzenlenen(null), !!duzenlenen);
  // ── KURAL SETİ (5 Eyl 2026, Serkan onayı) ─────────────────────────
  // 🔑 *"Med ve lisans rule seti bu modüle koyarız."*  Bir modül = bir mevzuat
  //    ailesi. 4 Eyl'de SHT-FCL'i FTL RULESET'e koymuştum — yanlış yerdi:
  //    orası görev-dinlenme mevzuatıdır. Taşındı.
  const [acikBloklar, setAcikBloklar] = useState({});
  const katla = (k) => setAcikBloklar(x => ({ ...x, [k]: !x[k] }));
  const [okunan, setOkunan] = useState(null);
  const fcl = useMemo(() => fclBloklari(), []);
  const fclKunye = useMemo(() => fclKunyesi(), []);
  const fclSirket = useMemo(() => fclSirketKurallari(), []);
  const basligi = (k) => String(k).replace(/_/g, ' ').toUpperCase();
  const gosterim = (v) => v === null || v === undefined ? '—'
    : Array.isArray(v) ? v.join(' · ') : typeof v === 'boolean' ? (v ? 'YES' : 'NO') : String(v);

  const load = useCallback(async () => {
    setYukleniyor(true);
    const { data, error } = await supabase.from('pilot_licence_med')
      .select('*').order('created_at', { ascending: false });
    if (error) { toast(`Could not read: ${error.message}`, 'error'); setYukleniyor(false); return; }
    // Pilot basina EN YENI satir gecerlidir (Ilke 4 — duzeltme yeni satir yazar).
    const m = {};
    (data || []).forEach(r => { if (!m[r.pilot_id]) m[r.pilot_id] = r; });
    setKayitlar(m); setYukleniyor(false);
  }, [toast]);
  useEffect(() => { load(); }, [load]);

  const ekip = useMemo(
    () => (pilots || []).filter(ucusEkibindenMi), [pilots]);

  const ac = (p) => {
    const r = kayitlar[p.id] || {};
    setForm({
      date_of_birth: r.date_of_birth || '', licence_type: r.licence_type || '',
      licence_number: r.licence_number || '', licence_country: r.licence_country || '',
      licence_issue: r.licence_issue || '', ir_valid_until: r.ir_valid_until || '',
      examiner_until: r.examiner_until || '', elp_level: r.elp_level ?? '',
      elp_valid_until: r.elp_valid_until || '', med_class: r.med_class ?? '',
      med_exam_date: r.med_exam_date || '', med_limitations: r.med_limitations || [],
      // Kodun kendi verisi de YÜKLENİR — yoksa düzeltme için açılan formda
      // kod görünür ama verisi boş gelir ve kaydedince SESSİZCE kaybolurdu.
      med_valid_until: r.med_valid_until || '', ssl_text: r.ssl_text || '',
      oal_types: (r.oal_types || []).join(', '),
      reason: '',
    });
    setDuzenlenen(p);
  };

  const [gerekceEksik, setGerekceEksik] = useState(false);
  // 🔴 6 Eyl 2026 — SERKAN SAHADA YAKALADI: *"Ekleyemedim, alttaki uyarı
  //    hızlıca kapanıyor. Bu ekranda çıkmalı, altta kaybolan değil."*
  //    Toast geçicidir; KAYDEDİLEMEDİ mesajı geçici olamaz — kullanıcı
  //    kaydettiğini sanıp modalı kapatırsa veri sessizce kaybolur (İlke 2).
  //    Hata artık FORMUN İÇİNDE durur ve ancak yeniden denenince silinir.
  const [kayitHatasi, setKayitHatasi] = useState(null);
  const kaydet = async () => {
    // 🔴 6 Eyl 2026 — SESSİZ KAPANMA (Serkan sahada yakaladı):
    //    *"TR yazdım, açıklama yazmadan SAVE dedim, yapmadı ama bana uyarı da
    //     vermedi."*  Düğme `disabled` idi; basınca HİÇBİR ŞEY olmuyordu ve
    //    `save()` içindeki toast'a hiç ulaşılmıyordu — yani kural vardı ama
    //    kullanıcıya ULAŞMIYORDU (İlke 2: sessiz kapanma yok).
    //    Düğme artık AÇIK; basınca eksik alan söylenir ve işaretlenir.
    setKayitHatasi(null);
    if (!gerekceTamam(form.reason)) {   // ortak kural (21 Eki 2026, K7): en az 3 karakter
      setGerekceEksik(true);
      toast(gerekceIpucuMetni(form.reason), 'error');
      return;
    }
    setGerekceEksik(false);

    // Kodun yanındaki veri eksikse kaydetme — kod tek başına ANLAMSIZDIR.
    const eksik = eksikVeriler(form);
    if (eksik.length) {
      setVeriEksik(eksik);
      toast(`${eksik.join(', ')} needs its own data before saving.`, 'error');
      return;
    }
    setVeriEksik([]);
    setKaydediliyor(true);
    const bos = (v) => (v === '' || v === undefined ? null : v);
    const { error } = await supabase.from('pilot_licence_med').insert([{
      customer_id: duzenlenen.customer_id || myProfile?.customer_id,
      pilot_id: duzenlenen.id,
      date_of_birth: bos(form.date_of_birth), licence_type: bos(form.licence_type),
      licence_number: bos(form.licence_number), licence_country: bos(form.licence_country),
      licence_issue: bos(form.licence_issue), ir_valid_until: bos(form.ir_valid_until),
      examiner_until: bos(form.examiner_until),
      elp_level: form.elp_level === '' ? null : Number(form.elp_level),
      elp_valid_until: bos(form.elp_valid_until),
      med_class: form.med_class === '' ? null : Number(form.med_class),
      med_exam_date: bos(form.med_exam_date), med_limitations: form.med_limitations || [],
      // Kodun kendi verisi — ilgili kod SEÇİLİ DEĞİLSE yazılmaz, eski bir
      // değer kayıtta artakalmasın (İlke 3: tek doğru, çelişki yok).
      med_valid_until: (form.med_limitations || []).includes('TML')
        ? bos(form.med_valid_until) : null,
      ssl_text: (form.med_limitations || []).includes('SSL')
        ? (form.ssl_text || '').trim() || null : null,
      oal_types: (form.med_limitations || []).includes('OAL')
        ? (form.oal_types || '').split(',').map(x => x.trim().toUpperCase()).filter(Boolean) : [],
      reason: form.reason.trim(), created_by: myProfile?.id ?? null,
    }]);
    setKaydediliyor(false);
    if (error) {
      // Toast DA çıkar (alışkanlık bozulmasın) ama asıl mesaj formda KALIR.
      setKayitHatasi(error.message || 'Unknown error');
      toast(`Could not save: ${error.message}`, 'error');
      return;
    }
    // Zil (IR/ELP/EXAMINER/MED tarihleri) beklemeden yeniden okur (29 Eyl 2026).
    toast('Saved.', 'success'); setDuzenlenen(null); load(); bildirimleriTazele();
  };

  // ── KISITLAMA SEÇİMİ (6 Eyl 2026) ──────────────────────────────
  // 🔑 Serkan: *"Medical seçince Limitation hücresi olsun, tıklayınca drop
  //    menüden her şey çıksın, çoklu seçim mümkün olsun."*
  const [kisitAcik, setKisitAcik] = useState(false);
  const [veriEksik, setVeriEksik] = useState([]);

  const kisit = (kod) => setForm(f => ({ ...f,
    med_limitations: (f.med_limitations || []).includes(kod)
      ? f.med_limitations.filter(x => x !== kod)
      : [...(f.med_limitations || []), kod] }));

  /** Sağlık sınıfı değişince o sınıfta GEÇERSİZ olan kodlar düşer — ama
   *  SESSİZCE değil (İlke 2): hangi kodun neden düştüğü söylenir. */
  const sinifDegisti = (deger) => {
    const yeniSinif = deger === '' ? null : Number(deger);
    setForm(f => {
      const secili = f.med_limitations || [];
      const kalan = secili.filter(kod => {
        const k = kisitlama(kod);
        return !k?.siniflar || yeniSinif == null || k.siniflar.includes(yeniSinif);
      });
      if (kalan.length !== secili.length) {
        const dusen = secili.filter(x => !kalan.includes(x));
        toast(`${dusen.join(', ')} removed — not applicable to class ${yeniSinif}.`, 'error');
      }
      return { ...f, med_class: deger, med_limitations: kalan };
    });
  };

  /** Kodun YANINDAKİ VERİ eksikse kaydettirmeyiz. Veritabanı da reddediyor
   *  ama oradan gelen kısıt mesajı kullanıcıya bir şey anlatmaz (İlke 2). */
  const eksikVeriler = (f) => {
    const secili = f.med_limitations || [];
    const eksik = [];
    if (secili.includes('TML') && !f.med_valid_until) eksik.push('TML');
    if (secili.includes('SSL') && !(f.ssl_text || '').trim()) eksik.push('SSL');
    if (secili.includes('OAL') && !(f.oal_types || '').trim()) eksik.push('OAL');
    return eksik;
  };

  const dilim = useSirketDilimi();
  const bugun = todayLocal(dilim.tz);
  /** Tarihli alanlar TRAINING ile AYNI eşiklerden geçer: 60 sarı · 30 amber ·
   *  15 kırmızı · geçmişse EXPIRED. Renk `STATE_COLOR`dan gelir, burada renk
   *  KARARI verilmez. */
  const tarih = (d, testid) => {
    if (!d) return <span style={{ color:C.t3 }}>—</span>;
    const st = trainingStatus(d, bugun);
    const renk = STATE_COLOR[st.state];
    return (
      <span data-testid={testid} data-durum={st.state}
            title={st.daysLeft == null ? '' : st.daysLeft < 0
              ? `Expired ${Math.abs(st.daysLeft)} day(s) ago`
              : `${st.daysLeft} day(s) left`}
            style={{ color: st.state === 'VALID' ? C.t1 : renk,
                     fontWeight: st.state === 'VALID' ? 400 : 700 }}>
        {d}{st.state !== 'VALID' && st.daysLeft != null && (
          <span style={{ color:C.t3, fontWeight:400 }}>
            {' '}· {st.daysLeft < 0 ? `${Math.abs(st.daysLeft)}d ago` : `${st.daysLeft}d`}
          </span>
        )}
      </span>
    );
  };

  return (
    <div style={S.wrap}>
      {dilimUyarisi(dilim) && (
        /* 🔴 SESSİZ DÜŞÜŞ YOK (İlke 1): ana üs çözülemediğinde tarihler cihazın
           yerelinde gösterilir ve bu EKRANDA YAZAR. Aksi hâlde "bugün"ün neye göre
           ölçüldüğü bakan kişiye bağlı kalırdı. */
        <div data-testid="dilim-yok"
             style={{ background:'rgba(224,160,32,0.12)', border:'1px solid var(--orange)',
                      borderRadius:6, padding:'7px 11px', margin:'0 0 10px',
                      fontSize:11, color:'var(--orange)', fontFamily:'var(--mono)' }}>
          {dilimUyarisi(dilim)}
        </div>)}
      <div style={S.note}>
        Entry point for personal, licence and medical facts. <b>Nothing here is duplicated
        elsewhere</b> — recurring checks (OPC, LPC, LC, CRM, DG, EMERG, SEC) stay in TRAINING with
        its own 60/30/15 alerts, and read what they need from here. Date of birth used to live
        inside a training row, which made FCL.065 impossible to apply; it belongs to the person,
        so it lives here. Every correction writes a new row — history is kept, nothing is deleted.
      </div>

      <div style={S.panel}>
        <div style={S.panelH}>
          <span style={S.panelT}>ATPL &amp; MED — {ekip.length} PILOT(S)</span>
          <span style={{ fontSize:9, color:C.t3, fontFamily:'var(--mono)' }}>
            SHT-FCL · SHT-MED
          </span>
        </div>
        <div style={{ overflowX:'auto' }}>
          <table style={S.table}>
            <thead><tr>{['PILOT', 'AGE', 'LICENCE', 'IR UNTIL', 'ELP UNTIL', 'MED / VALID UNTIL', 'LIMITATIONS', 'FCL.065', '']
              .map((h, i) => <th key={i} style={S.th}>{h}</th>)}</tr></thead>
            <tbody>
              {yukleniyor && <tr><td style={S.td} colSpan={9}>LOADING…</td></tr>}
              {!yukleniyor && ekip.map(p => {
                const r = kayitlar[p.id];
                const y = yas(r?.date_of_birth, bugun);      // ana üs günü — tarih sütunlarıyla aynı (21 Eki 2026)
                const k = fcl065(r?.date_of_birth, bugun);
                return (
                  <tr key={p.id} data-testid={`plm-${p.code}`}>
                    <td style={{ ...S.td, color:C.accent, fontWeight:700 }}>
                      {p.code} — {(p.full_name || '').toUpperCase()}
                    </td>
                    <td style={S.td}>{y == null ? <span style={badge('red')}>NOT SET</span> : y}</td>
                    <td style={S.td}>
                      {r?.licence_type ? `${r.licence_type} ${r.licence_number || ''}`.trim() : '—'}
                    </td>
                    <td style={S.td}>{tarih(r?.ir_valid_until, `ir-${p.code}`)}</td>
                    <td style={S.td}>
                      {!r?.elp_level ? <span style={{ color:C.t3 }}>—</span>
                        : r.elp_level === 6
                          ? <>L6 <span style={{ color:C.t3 }}>∞</span></>
                          : <>L{r.elp_level} · {tarih(r.elp_valid_until, `elp-${p.code}`)}</>}
                    </td>
                    {/* 🔑 Serkan (6 Eyl 2026): *"Tek hücrede göstereceksek
                        MED / VALID UNTIL başlığı olması gerekir"* · *"Sadece
                        MED açıklayıcı değil."*
                        🔴 Burada gösterilen artık MUAYENE TARİHİ DEĞİL, ondan
                        türetilen SON GEÇERLİLİK. Eskisi muayene tarihiydi ve
                        başlık da yalnız "MED" dediği için hangisi olduğu
                        anlaşılmıyordu — nitekim kayıtlara muayene tarihi
                        yerine bitiş tarihi girilmişti. */}
                    <td style={S.td}>
                      {!r?.med_class ? <span style={{ color:C.t3 }}>—</span> : (() => {
                        const b = medBitisi(r);
                        return <>CLASS {r.med_class} · {b.tarih
                          ? tarih(b.tarih, `med-${p.code}`)
                          : <span style={{ color:C.amber }} data-testid={`med-${p.code}`}>
                              ? <span style={{ color:C.t3, fontSize:10 }}>({b.eksik})</span>
                            </span>}</>;
                      })()}
                    </td>
                    <td style={S.td}>
                      {(r?.med_limitations || []).length
                        ? r.med_limitations.map(x => (
                            <span key={x} style={{ ...badge('amber'), marginRight:4 }}>{x}</span>))
                        : <span style={{ color:C.t3 }}>—</span>}
                    </td>
                    <td style={S.td}>
                      {!k ? <span style={{ color:C.t3 }}>—</span> : (
                        <span style={badge(k.state)}>
                          {k.state === 'red' ? '65+ NOT ELIGIBLE' : '60+ MULTI-PILOT ONLY'}
                        </span>
                      )}
                      {k && <InfoDot testid={`plm-065-${p.code}`} title="FCL.065 — AGE LIMIT"
                        note={k.text}
                        rule={'SHT-FCL FCL.065: "(a) 60-64 yaş: … çok pilotlu ekibin bir üyesi '
                          + 'olmadığı sürece, ticari hava taşımacılığı operasyonlarındaki bir hava '
                          + 'aracının pilotu olarak uçamaz. (b) 65 yaş: … uçamaz."'}
                        action={k.state === 'red'
                          ? 'Do not roster this pilot on commercial air transport.'
                          : 'Roster only as part of a multi-pilot crew.'} />}
                    </td>
                    <td style={S.td}>
                      {!readOnly && (
                        <button style={S.btnS} onClick={() => ac(p)}>
                          {r ? 'UPDATE' : 'ENTER'}
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── KURAL SETİ: SHT-FCL + SHT-MED ───────────────────────────── */}
      <div style={{ ...S.panelT, fontSize:13, margin:'26px 0 8px' }}>
        SHT-FCL — LICENCE VALIDITY{fclKunye.revision ? ` · ${fclKunye.revision}` : ''}
        {fclKunye.issued ? ` · ${fclKunye.issued}` : ''}
      </div>
      <div style={{ ...S.note, marginBottom:10 }}>
        {fclKunye.scope}
        {fclGeceTanimi() && <> <b>NIGHT</b>: {fclGeceTanimi().text} ({fclGeceTanimi().reference})</>}
      </div>

      {fcl.map(blok => (
        <Katlanir key={`fcl-${blok.key}`} baslik={basligi(blok.key)} kunye={blok.reference}
                  sayi={blok.rows.length} acikMi={!!acikBloklar[`fcl-${blok.key}`]}
                  onToggle={() => katla(`fcl-${blok.key}`)}>
          {blok.note && <div style={S.note}>{blok.note}</div>}
          <div style={{ overflowX:'auto' }}>
            <table style={S.table}>
              <thead><tr>{['PARAMETER', 'FCL VALUE', 'STATUS', ''].map((h, i) =>
                <th key={i} style={S.th}>{h}</th>)}</tr></thead>
              <tbody>
                {blok.rows.map(r => {
                  const acik = okunan === `fcl-${r.path}`;
                  return (
                    <React.Fragment key={r.path}>
                      <tr>
                        <td style={S.td}>{r.label}</td>
                        <td style={{ ...S.td, color:C.t3 }}>{gosterim(r.value)}</td>
                        <td style={S.td}><span style={badge('dim')}>LOCKED</span></td>
                        <td style={{ ...S.td, textAlign:'right' }}>
                          <button type="button" aria-expanded={acik}
                            aria-label={`READ THE SHT-FCL ARTICLE — ${r.label}`}
                            onClick={() => setOkunan(acik ? null : `fcl-${r.path}`)}
                            style={{ ...S.btnS, padding:'1px 7px', fontSize:11, borderRadius:9,
                                     borderColor: acik ? C.accent : undefined,
                                     color: acik ? C.accent : C.t3 }}>ⓘ</button>
                        </td>
                      </tr>
                      {acik && (
                        <tr><td colSpan={4} style={{ ...S.td, background:C.bg3 }}>
                          <div style={{ fontSize:10, color:C.t3, marginBottom:6 }}>
                            SHT-FCL{r.reference ? ` — ${r.reference}` : ''}
                          </div>
                          {fclMetni(r.reference || blok.reference) ? (
                            <div style={{ maxHeight:260, overflowY:'auto', whiteSpace:'pre-wrap',
                                          fontSize:12, lineHeight:1.65, color:C.t2 }}>
                              {fclMetni(r.reference || blok.reference)}
                            </div>
                          ) : (
                            <div style={{ color:C.amber, fontSize:12 }}>
                              THE ARTICLE TEXT IS NOT AVAILABLE — READ IT IN THE INSTRUCTION ITSELF.
                            </div>
                          )}
                        </td></tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Katlanir>
      ))}

      <Katlanir baslik="COMPANY DECISIONS (FCL)" kunye="— operator" sayi={fclSirket.length}
                acikMi={!!acikBloklar['fcl-company']} onToggle={() => katla('fcl-company')}>
        <div style={{ overflowX:'auto' }}>
          <table style={S.table}>
            <thead><tr>{['PARAMETER', 'VALUE', 'REFERENCE', ''].map((h, i) =>
              <th key={i} style={S.th}>{h}</th>)}</tr></thead>
            <tbody>
              {fclSirket.map(c => (
                <tr key={c.key}>
                  <td style={S.td}>{c.label}</td>
                  <td style={{ ...S.td, color:C.t2 }}>
                    {String(c.value)}
                    {c.options && <span style={{ color:C.t3, fontSize:10 }}> · of {c.options.join(' / ')}</span>}
                  </td>
                  <td style={{ ...S.td, color:C.t3, fontSize:11 }}>{c.reference || '—'}</td>
                  <td style={{ ...S.td, textAlign:'right' }}>
                    {c.note && <InfoDot testid={`fcl-company-${c.key}`} title="COMPANY DECISION"
                      note={c.note}
                      rule={c.reference ? `Related article: ${c.reference}` : 'No SHT-FCL counterpart.'}
                      action="Changing it is a safety decision — record the reason." />}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Katlanir>

      {/* ── KISITLAMA KODLARI — ONSEKİZ KOD ──────────────────────────
          🔴 KAYNAK KARIŞTIRILMAZ (6 Eyl 2026): SHT-MED yalnız BEŞ kodu
             yazıyor (OML/OSL/ORL/OPL/SSL). Kalanlar orada geçmez; çünkü
             SHT-MED Md.13(2) *"…EASA tarafından yayımlanan AMC ve GM …
             aynen kabul edilir ve uygulanır"* diyor ve EK-1 md.1 Sınıf
             1/2/LAPL için PART-MED AMC+GM'e yönlendiriyor. Bu yüzden her
             satır KENDİ künyesini taşır — hiçbir kod olmadığı kaynaktan
             gelmiş gibi görünmez (İlke 1). */}
      <Katlanir baslik="MEDICAL LIMITATION CODES" kunye={AMC_KUNYE}
                sayi={MED_KISITLAMALARI.length} acikMi={!!acikBloklar['med']}
                onToggle={() => katla('med')}>
        <div style={{ overflowX:'auto' }}>
          <table style={S.table}>
            <thead><tr>{['CODE', 'MEANING', 'SCOPE', 'EFFECT ON ASSIGNMENT', ''].map((h, i) =>
              <th key={i} style={S.th}>{h}</th>)}</tr></thead>
            <tbody>
              {MED_KISITLAMALARI.map(k => (
                <tr key={k.kod}>
                  <td style={S.td}>
                    <span style={badge(k.ops === 'gate' ? 'red' : k.ops ? 'amber' : null)}>{k.kod}</span>
                  </td>
                  <td style={{ ...S.td, whiteSpace:'normal', color:C.t2, minWidth:260 }}>{k.ad}</td>
                  <td style={{ ...S.td, fontSize:10.5, color:C.t3 }}>{k.kapsam}</td>
                  <td style={{ ...S.td, whiteSpace:'normal', fontSize:10.5, minWidth:200 }}>
                    {k.ops === 'gate' ? <span style={{ color:C.red }}>BLOCKS ASSIGNMENT</span>
                      : k.ops === 'validity' ? <span style={{ color:C.amber }}>OVERRIDES MEDICAL EXPIRY</span>
                      : k.ops === 'amber' ? <span style={{ color:C.amber }}>SHOWN TO DISPATCHER, DOES NOT BLOCK</span>
                      : <span style={{ color:C.t3 }}>Pilot&apos;s own duty — assignment unchanged</span>}
                  </td>
                  <td style={{ ...S.td, textAlign:'right' }}>
                    <InfoDot testid={`med-${k.kod}`} title={`${k.kod} — ${k.ad}`} note={k.not}
                      rule={k.kaynak}
                      action={k.veri
                        ? 'This code needs its own data on the pilot record — without it the code says nothing.'
                        : k.ops === 'gate'
                          ? 'Recorded per pilot; the assignment gate reads it for the whole selected crew.'
                          : 'Enter it on the pilot record so the rules can see it.'} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* NE ÖLÇEMEDİĞİMİZ DE YAZILIR — kural seti neyi denetlediğini
            dürüstçe söylemezse, denetlemediği yer sessizce açık kalır. */}
        <div style={{ ...S.note, borderLeftColor:C.amber }}>
          <b>OCL — what the system does NOT check.</b> AMC2 MED.B.001(b)(13) restricts the holder
          to the role of co-pilot. In this system crew roles are PF / PM / CRZ CPT; there is no
          PIC / co-pilot rank in the roster, and flying as PF is not the same as being PIC.
          The gate therefore checks only the <i>necessary</i> condition — that another pilot on the
          crew is free of OML and OCL and can act as PIC. <b>The seat itself is not verified.</b>
        </div>
      </Katlanir>

      {fclOlculebilirlik() && (
        <div style={{ ...S.note, borderLeftColor:C.amber }}>
          <b>NOT MEASURED</b> — {fclOlculebilirlik().not_measurable_today.join(' · ')}
        </div>
      )}

      {duzenlenen && (
        <div onClick={() => setDuzenlenen(null)}
             style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.55)', display:'flex',
                      alignItems:'center', justifyContent:'center', zIndex:90, overflowY:'auto' }}>
          <div onClick={e => e.stopPropagation()}
               style={{ background:C.bg2, border:`1px solid ${C.border}`, borderRadius:10,
                        width:620, maxWidth:vw(94), margin:'24px 0' }}>
            <div style={S.panelH}>
              <span style={S.panelT}>
                ATPL &amp; MED — {duzenlenen.code} {(duzenlenen.full_name || '').toUpperCase()}
              </span>
              <KapatX onClose={() => setDuzenlenen(null)} disabled={kaydediliyor} style={{ marginLeft:'auto' }} />
            </div>
            <div style={{ padding:16 }}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12 }}>
                <div>
                  <span style={S.label}>Date of birth</span>
                  <input type="date" style={S.input} data-testid="plm-dob"
                    value={form.date_of_birth || ''}
                    onChange={e => setForm(f => ({ ...f, date_of_birth: e.target.value }))} />
                </div>
                <div>
                  <span style={S.label}>Licence</span>
                  <select style={S.input} value={form.licence_type || ''}
                    onChange={e => setForm(f => ({ ...f, licence_type: e.target.value }))}>
                    <option value="">—</option>
                    {LISANS.map(x => <option key={x} value={x}>{x}</option>)}
                  </select>
                </div>
                <div>
                  <span style={S.label}>Licence no</span>
                  <HarfliGiris style={S.input} value={form.licence_number || ''}
                    onChange={v => setForm(f => ({ ...f, licence_number: v }))} />
                </div>
                <div>
                  <span style={S.label}>Issued by (country)</span>
                  <select style={S.input} value={form.licence_country || ''}
                    onChange={e => setForm(f => ({ ...f, licence_country: e.target.value }))}>
                    <option value="">—</option>
                    {TZ_ULKELER.map(u => (
                      <option key={u.cc} value={u.cc}>{u.cc} — {u.ulke.toUpperCase()}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <span style={S.label}>Licence issue</span>
                  <input type="date" style={S.input} value={form.licence_issue || ''}
                    onChange={e => setForm(f => ({ ...f, licence_issue: e.target.value }))} />
                </div>
                <div>
                  <span style={S.label}>IR valid until</span>
                  <input type="date" style={S.input} value={form.ir_valid_until || ''}
                    onChange={e => setForm(f => ({ ...f, ir_valid_until: e.target.value }))} />
                </div>
                <div>
                  <span style={S.label}>ELP level</span>
                  <select style={S.input} value={form.elp_level ?? ''}
                    onChange={e => setForm(f => ({ ...f, elp_level: e.target.value }))}>
                    <option value="">—</option>
                    {[4, 5, 6].map(x => <option key={x} value={x}>LEVEL {x}{x === 6 ? ' (∞)' : ''}</option>)}
                  </select>
                </div>
                <div>
                  <span style={S.label}>ELP valid until</span>
                  <input type="date" style={S.input} value={form.elp_valid_until || ''}
                    disabled={String(form.elp_level) === '6'}
                    title={String(form.elp_level) === '6' ? 'Level 6 has no expiry.' : ''}
                    onChange={e => setForm(f => ({ ...f, elp_valid_until: e.target.value }))} />
                </div>
                <div>
                  <span style={S.label}>Examiner until (FCL.1025)</span>
                  <input type="date" style={S.input} value={form.examiner_until || ''}
                    onChange={e => setForm(f => ({ ...f, examiner_until: e.target.value }))} />
                </div>
                <div>
                  <span style={S.label}>Medical class</span>
                  <select style={S.input} value={form.med_class ?? ''}
                    data-testid="plm-med-class"
                    onChange={e => sinifDegisti(e.target.value)}>
                    <option value="">—</option><option value="1">CLASS 1</option><option value="2">CLASS 2</option>
                  </select>
                </div>
                <div>
                  <span style={S.label}>Last exam date</span>
                  <input type="date" style={S.input} data-testid="plm-exam-date"
                    value={form.med_exam_date || ''}
                    onChange={e => setForm(f => ({ ...f, med_exam_date: e.target.value }))} />
                </div>
                {/* ── SON TARİH OTOMATİK GELİR ─────────────────────────
                    🔑 Serkan (6 Eyl 2026): *"Last exam date / due date —
                       gelecek muayene için son tarih, bu muayene tarihini
                       girince otomatik gelmeli zaten."* · *"Yaşa ve limite
                       göre."*
                    Elle GİRİLMEZ: yaşa göre MED.A.045'in 12/6 ayı, TML varsa
                    sertifikanın kendi tarihi. Hesap `medBitisi`de — form,
                    tablo ve zil aynı yerden okur. */}
                <div>
                  <span style={S.label}>Valid until (auto)</span>
                  {(() => {
                    const b = medBitisi({
                      date_of_birth: form.date_of_birth,
                      med_exam_date: form.med_exam_date,
                      med_class: form.med_class === '' || form.med_class == null
                        ? null : Number(form.med_class),
                      med_limitations: form.med_limitations || [],
                      med_valid_until: form.med_valid_until,
                    });
                    return (
                      <div data-testid="plm-valid-until"
                           style={{ ...S.input, background:'transparent',
                                    borderStyle:'dashed', color: b.tarih ? C.green : C.amber }}>
                        {b.tarih || '—'}
                        <span style={{ color:C.t3, fontSize:10, marginLeft:7 }}>
                          {b.tarih
                            ? (b.kaynak === 'TML' ? 'TML' : `MED.A.045 · ${b.ay} MONTHS`)
                            : b.eksik}
                        </span>
                      </div>
                    );
                  })()}
                </div>
              </div>

              {/* ── KISITLAMALAR — ÇOKLU SEÇİM MENÜSÜ ──────────────────
                  🔑 Serkan (6 Eyl 2026): *"Medical seçince Limitation hücresi
                     olsun, tıklayınca drop menüden her şey çıksın, çoklu seçim
                     mümkün olsun."*  ·  *"Şimdi bana tanımlı limitleri
                     listele."*
                  Liste SAĞLIK SINIFINA göre süzülür: AMC2 MED.B.001'de OML/OCL
                  yalnız Sınıf 1'e, OSL/OPL/ORL ve VCL yalnız Sınıf 2 ve LAPL'e
                  uygulanır. Sınıf boşsa SÜZME YAPILMAZ — boş alan "şu kod
                  olmaz" demez (İlke 1). */}
              <div style={{ marginTop:14 }}>
                <span style={S.label}>Medical limitations</span>
                <button type="button" data-testid="limit-cell"
                  onClick={() => setKisitAcik(a => !a)}
                  style={{ ...S.input, textAlign:'left', cursor:'pointer',
                           display:'flex', justifyContent:'space-between', gap:8 }}>
                  <span style={{ color: (form.med_limitations || []).length ? C.amber : C.t3 }}>
                    {(form.med_limitations || []).length
                      ? form.med_limitations.join(' · ')
                      : 'None — click to select'}
                  </span>
                  <span style={{ color:C.t3 }}>{kisitAcik ? '▲' : '▼'}</span>
                </button>

                {kisitAcik && (
                  <div data-testid="limit-menu"
                       style={{ border:`1px solid ${C.border2}`, borderTop:'none',
                                background:C.bg3, borderRadius:'0 0 4px 4px',
                                maxHeight:300, overflowY:'auto', padding:'6px 0' }}>
                    {['Görme', 'İşitme / fiziksel', 'Operasyonel', 'İdari'].map(grup => {
                      const kodlar = kisitlamaSecenekleri(
                        form.med_class === '' || form.med_class == null
                          ? null : Number(form.med_class)
                      ).filter(k => k.grup === grup);
                      if (!kodlar.length) return null;
                      return (
                        <div key={grup}>
                          <div style={{ ...S.label, margin:'8px 12px 4px', color:C.accent }}>{grup}</div>
                          {kodlar.map(k => {
                            const secili = (form.med_limitations || []).includes(k.kod);
                            return (
                              <button key={k.kod} type="button" onClick={() => kisit(k.kod)}
                                data-testid={`limit-${k.kod}`}
                                style={{ display:'flex', gap:9, width:'100%', textAlign:'left',
                                         background:'none', border:'none', cursor:'pointer',
                                         padding:'5px 12px', fontFamily:'var(--mono)',
                                         fontSize:11.5, alignItems:'flex-start',
                                         color: secili ? C.amber : C.t2 }}>
                                <IsaretKutusu isaretli={secili} renk="var(--amber)" />
                                <span style={{ fontWeight:700, minWidth:34 }}>{k.kod}</span>
                                <span style={{ fontWeight:400, lineHeight:1.5 }}>{k.ad}</span>
                                {k.ops && <span style={badge(k.ops === 'gate' ? 'red' : 'amber')}>
                                  {k.ops === 'gate' ? 'OPS' : k.ops === 'validity' ? 'VALIDITY' : 'ADVISORY'}
                                </span>}
                              </button>
                            );
                          })}
                        </div>
                      );
                    })}
                    <div style={{ padding:'8px 12px 4px' }}>
                      <button type="button" style={S.btnS} onClick={() => setKisitAcik(false)}>DONE</button>
                    </div>
                  </div>
                )}

                {/* Seçilen her kodun TAM METNİ ve künyesi — ⓘ ile açılır. */}
                {(form.med_limitations || []).map(kod => {
                  const k = kisitlama(kod);
                  if (!k) return null;
                  return (
                    <div key={kod} style={{ ...S.note, borderLeftColor:
                        k.ops === 'gate' ? C.red : k.ops ? C.amber : C.border2 }}>
                      <b>{k.kod}</b> — {k.ad}
                      {' '}<InfoDot testid={`limit-info-${k.kod}`} title={`${k.kod} — ${k.ad}`}
                              note={k.not} rule={k.kaynak} />
                      <div style={{ fontSize:10, color:C.t3, marginTop:3 }}>{k.kapsam} · {k.kaynak}</div>
                    </div>
                  );
                })}

                {/* ── KODUN KENDİ VERİSİ ────────────────────────────────
                    Üç kodun ETKİSİ kodun kendisinde değil, yanındaki veride
                    saklı. Bunlar girilmeden kod ANLAMSIZDIR: motor
                    "kısıtlama var" der ama ne olduğunu bilemez. */}
                {(form.med_limitations || []).includes('TML') && (
                  <div style={{ marginTop:10 }}>
                    <span style={{ ...S.label, color: veriEksik.includes('TML') ? C.red : C.t3 }}>
                      TML — medical valid until (from the certificate)
                    </span>
                    <input type="date" data-testid="plm-tml-date"
                      {...zKayit(S.input, !!form.med_valid_until, veriEksik.includes('TML'))}
                      value={form.med_valid_until || ''}
                      onChange={e => setForm(f => ({ ...f, med_valid_until: e.target.value }))} />
                    <div style={{ fontSize:10, color:C.t3, marginTop:4 }}>
                      This date REPLACES the 12/6-month calculation — MED.A.045 is not applied.
                    </div>
                  </div>
                )}

                {(form.med_limitations || []).includes('SSL') && (
                  <div style={{ marginTop:10 }}>
                    <span style={{ ...S.label, color: veriEksik.includes('SSL') ? C.red : C.t3 }}>
                      SSL — special restriction, as written on the certificate
                    </span>
                    <HarfliGiris as="textarea" data-testid="plm-ssl-text"
                      {...zKayit({ ...S.input, minHeight:52, resize:'vertical' }, !!(form.ssl_text || '').trim(), veriEksik.includes('SSL'))}
                      value={form.ssl_text || ''}
                      onChange={v => setForm(f => ({ ...f, ssl_text: v }))} />
                    <div style={{ fontSize:10, color:C.t3, marginTop:4 }}>
                      Shown to the dispatcher at assignment. It does not block the flight.
                    </div>
                  </div>
                )}

                {(form.med_limitations || []).includes('OAL') && (
                  <div style={{ marginTop:10 }}>
                    <span style={{ ...S.label, color: veriEksik.includes('OAL') ? C.red : C.t3 }}>
                      OAL — demonstrated aircraft type(s), comma separated
                    </span>
                    <HarfliGiris data-testid="plm-oal-types"
                      {...zKayit(S.input, !!(form.oal_types || '').trim(), veriEksik.includes('OAL'))}
                      value={form.oal_types || ''}
                      onChange={v => setForm(f => ({ ...f, oal_types: v }))} />
                  </div>
                )}

                {veriEksik.length > 0 && (
                  <div data-testid="plm-limit-error" style={{ color:C.red, fontSize:11, marginTop:6 }}>
                    {veriEksik.join(', ')} needs its own data — the code alone says nothing.
                  </div>
                )}
              </div>

              <div style={{ marginTop:12 }}>
                <span style={{ ...S.label, color: gerekceEksik ? C.red : C.t3 }}>
                  Reason (mandatory — audit trail)
                </span>
                <HarfliGiris as="textarea" data-testid="plm-reason"
                  {...zKayit({ ...S.input, minHeight:60, resize:'vertical' }, gerekceTamam(form.reason), gerekceEksik)}
                  value={form.reason || ''}
                  onChange={v => { setForm(f => ({ ...f, reason: v }));
                                   if (gerekceTamam(v)) setGerekceEksik(false); }} />
                {/* Düğme açık kalır, basınca eksik söylenir (bu ekranın kararı); satırın metni ortak (21 Eki 2026, K7). */}
                {gerekceEksik ? (
                  <div data-testid="plm-reason-error" style={{ color:C.red, fontSize:11, marginTop:4 }}>
                    {gerekceIpucuMetni(form.reason)}
                  </div>
                ) : <GerekceIpucu metin={form.reason} testid="plm-reason-ipucu" />}
              </div>

              {/* ── KAYDEDİLEMEDİ — EKRANDA KALIR ─────────────────────
                  Serkan (6 Eyl): *"Bu ekranda çıkmalı, altta kaybolan
                  değil."*  Kaydın reddedildiğini söyleyen mesaj kaybolursa
                  kullanıcı kaydettiğini sanır. */}
              {kayitHatasi && (
                <div data-testid="plm-save-error"
                     style={{ ...S.note, borderLeftColor:C.red, background:'var(--bg3)',
                              color:C.red, marginTop:12 }}>
                  <b>NOT SAVED — nothing was written.</b>
                  <div style={{ marginTop:4, color:C.t2, fontSize:11 }}>{kayitHatasi}</div>
                  {/column|schema cache/i.test(kayitHatasi) && (
                    <div style={{ marginTop:6, color:C.t3, fontSize:10.5 }}>
                      A column the form writes is missing in the database. The migration for
                      this release has not been run yet — run it, then save again.
                    </div>
                  )}
                </div>
              )}

              <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:14 }}>
                <button style={S.btnS} onClick={() => setDuzenlenen(null)}>CANCEL</button>
                {/* Düğme SESSİZCE KAPATILMAZ: basıldığında eksik olan söylenir.
                    Kapalı düğme "neden çalışmıyor" sorusunu cevapsız bırakır. */}
                <button style={S.btnP} disabled={kaydediliyor}
                  onClick={kaydet}>{kaydediliyor ? 'SAVING…' : 'SAVE'}</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
